// Aucun emoji dans les libellés : les icônes sont posées côté composant
// via <Icon name="…" /> (voir src/icons.js).
const TRANSLATIONS = {
  fr: {
    brand: "Setal Express",
    heroSubtitle: "Le service de pressing premium à Dakar.",
    heroFeatures: "Collecte à domicile · Nettoyage professionnel · Livraison rapide",
    orderBtn: "Demande de collecte",
    trackBtn: "Suivre ma commande",
    stats1: "500+", stats1Label: "Clients satisfaits",
    stats2: "24h", stats2Label: "Délai moyen",
    stats3: "100%", stats3Label: "Qualité garantie",
    servicesTitle: "Nos Services",
    servicesSubtitle: "Un traitement professionnel pour tous vos vêtements",
    pricingTitle: "Nos Tarifs",
    pricingSubtitle: "Transparents et compétitifs",
    howTitle: "Comment ça marche",
    howSubtitle: "Simple, rapide et efficace",
    // [numéro, nom d'icône, titre, description]
    howSteps: [
      ["1", "mobile",   "Commandez",  "Remplissez le formulaire en ligne"],
      ["2", "collect",  "Collecte",   "Nous venons chercher vos vêtements"],
      ["3", "washing",  "Nettoyage",  "Traitement professionnel"],
      ["4", "delivery", "Livraison",  "Vêtements livrés chez vous"],
    ],
    testimonialsTitle: "Ce que disent nos clients",
    ctaTitle: "Prêt à commander ?",
    ctaSubtitle: "Collecte et livraison à domicile à Dakar",
    footerRights: "Tous droits réservés.",
    orderTitle: "Demande de collecte",
    step1: "Contact", step2: "Détails", step3: "Confirmation",
    nameLabel: "Nom complet", phoneLabel: "Téléphone", addressLabel: "Adresse",
    dateLabel: "Date", timeLabel: "Heure", notesLabel: "Notes",
    nextBtn: "Suivant", prevBtn: "Retour", submitBtn: "Confirmer la commande",
    trackTitle: "Suivi de commande",
    trackPlaceholder: "N° commande (ex : CMD123456)",
    searchBtn: "Rechercher",
    loginTitle: "Connexion",
    loginSubtitle: "Connexion espace professionnel",
    loginId: "Identifiant", loginPass: "Mot de passe",
    loginBtn: "Se connecter",
    logout: "Déconnexion",
    back: "Retour",
    backHome: "Retour à l'accueil",
    backSite: "Retour au site",
    confirmed: "Commande confirmée",
    confirmedMsg: "Votre commande a bien été enregistrée. Nous vous contacterons pour confirmer la collecte.",
    orderNum: "Votre numéro de commande",
    keepNum: "Conservez ce numéro pour le suivi",
    trackMyOrder: "Suivre ma commande",
    estimateTitle: "Estimez votre prix",
    estimateSubtitle: "Sélectionnez vos articles pour estimer le coût",
    estimateTotal: "Total estimé",
    estimateCta: "Commander avec ces articles",
    loyaltyTitle: "Programme fidélité",
    loyaltyPoints: "points fidélité",
    loyaltyFree: "collectes gratuites disponibles",
    loyaltyProgress: "Encore {n} commandes avant votre prochaine collecte gratuite",
    commander: "Commander",
    suivre: "Suivre",
    yourCoords: "Vos coordonnées",
    collectDetails: "Détails de la collecte",
    summary: "Récapitulatif",
    sending: "Envoi…",
    notFound: "Commande introuvable. Vérifiez le numéro.",
    order: "Commande",
    client: "Client",
    telephone: "Téléphone",
    date: "Date",
    articles: "Articles",
    total: "Total",
    qrTitle: "QR Code de suivi",
    qrDesc: "Scannez ce code pour accéder à votre suivi",
    downloadPdf: "Télécharger le reçu PDF",
    loyaltyBadge: "Client fidèle",
    fillFields: "Veuillez remplir tous les champs.",
  },
};

export default TRANSLATIONS;
